import { render, staticRenderFns } from "./newpublicWorkFlowDefine.vue?vue&type=template&id=5485d2a3&scoped=true&"
import script from "./newpublicWorkFlowDefine.vue?vue&type=script&lang=js&"
export * from "./newpublicWorkFlowDefine.vue?vue&type=script&lang=js&"
import style0 from "./newpublicWorkFlowDefine.vue?vue&type=style&index=0&id=5485d2a3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5485d2a3",
  null
  
)

export default component.exports